import { useNavigate } from 'react-router-dom';

import { type CaraWorkspaceFieldsFragment } from '@oysterjs/ais/api/graphql';
import { FEATURE_FLAGS, useFlag } from '@oysterjs/ais/components/feature-flags';
import { bulkDraftPath } from '@oysterjs/ais/components/mailbox/bulk-send-paths';
import { useLiveBulkDraft } from '@oysterjs/ais/components/workspaces/hooks/use-live-bulk-draft';
import {
  bulkEmailDraftCardState,
  bulkEmailDraftSendId
} from '@oysterjs/ais/components/workspaces/lib/bulk-email-draft-event';

import { BulkEmailDraftArtifact } from './artifact-cards';

type StageEvent = CaraWorkspaceFieldsFragment['planStages'][0]['events'][0];

const LiveBulkEmailDraftCard = ({ event }: { event: StageEvent }) => {
  const navigate = useNavigate();
  const bulkSendId = bulkEmailDraftSendId(event);
  const bulkDraft = useLiveBulkDraft(bulkSendId, event.endedAt);
  // What the tool answered stands in until the bulk draft has been read.
  const toolOutput = event.toolCall?.bulkEmailDraftTool?.output;
  return (
    <BulkEmailDraftArtifact
      name={bulkDraft?.name ?? toolOutput?.name}
      recipientCount={bulkDraft?.recipients.length ?? toolOutput?.recipients.length}
      state={bulkEmailDraftCardState(event, bulkDraft)}
      onOpen={bulkSendId ? () => navigate(bulkDraftPath(bulkSendId)) : undefined}
    />
  );
};

/** The card for a bulk draft Cara made or changed, which opens its page in Mailbox. */
export const BulkEmailDraftEvent = ({ event }: { event: StageEvent }) => {
  const isBulkSendEnabled = useFlag(FEATURE_FLAGS.MAILBOX_BULK_SEND);
  return isBulkSendEnabled ? <LiveBulkEmailDraftCard event={event} /> : null;
};
